import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';
import { checkDayToDay } from '@/utils/changeDate';

import { getArrayOfRules } from '@/utils/getDataForm';
import { inject, onMounted, provide, ref, watch } from 'vue';

import { useCheckAvailablePickedTime } from '@/newCargoPickUpPage/hooks/useCheckAvailablePickedTime';
import { useFetchAvailablePickUpTime } from '@/newCargoPickUpPage/hooks/useFetchAvailablePickUpTime';
import { useFetchExtraPackaging } from '@/newCargoPickUpPage/hooks/useFetchExtraPackaging';
import { useFetchSuitableOffices } from '@/newCargoPickUpPage/hooks/useFetchSuitableOffices';
import { useGetAvailableCargoNatures } from '@/newCargoPickUpPage/hooks/useGetAvailableCargoNatures';
import { useCitiesRestrictions } from '@/stores/citiesRestrictions';
import { ExtraPackagingList } from './../../../Components';

export default {
  components: {
    ExtraPackagingList,
  },
  setup() {
    const dataForm = useNewDataFormCargoPickUpStore();

    const extraPackaging = ref([]);

    provide('extraPackaging', extraPackaging);

    const handleChangePayer = inject('handleChangePayer');

    const validateCounterparties = inject('validateCounterparties');

    const cargoNatures = useGetAvailableCargoNatures();

    const handleChangeTypeOfPayment = inject('handleChangeTypeOfPayment');

    const natureOfCargoList = ref([
      { title: 'Бампер', value: 'Бампер' },
      { title: 'Крыло', value: 'Крыло' },
    ]);

    const ruleFormRef = inject('ruleFormRef', {});

    const handleChangeEventCargoInfo = () => {
      useFetchExtraPackaging();

      useFetchSuitableOffices('acceptanceCargo');
      useFetchSuitableOffices('issuanceOfCargo');

      useFetchAvailablePickUpTime();
      useCheckAvailablePickedTime(validateCounterparties);
    };

    const handleNatureCargoChange = () => {
      useFetchExtraPackaging();
    };

    // watch(
    //   [
    //     () => dataForm.cargoInformation.cargoWeight,
    //     () => dataForm.cargoInformation.cargoDimensions.height,
    //     () => dataForm.cargoInformation.cargoDimensions.length,
    //     () => dataForm.cargoInformation.cargoDimensions.width,
    //     () => dataForm.cargoInformation.sizeOfCargoCylinder.diameter,
    //     () => dataForm.cargoInformation.sizeOfCargoCylinder.height,
    //     () => dataForm.cargoInformation.natureOfCargo,
    //     () => dataForm.cargoInformation.typeOfCargo,
    //   ],
    //   () => {
    //     useFetchExtraPackaging();
    //   }
    // );

    const cityFromRestrictions = inject('cityFromRestrictions');
    const cityToRestrictions = inject('cityToRestrictions');

    const citiesRestrictions = useCitiesRestrictions();

    const dialogBadDimensionsInfo = ref({ maxHeight: -1, maxWeight: -1, maxSize: -1, open: false });

    const typeOfCargos = [
      {
        id: 1,
        title: 'Стандарт',
      },
      {
        id: 2,
        title: 'Цилиндры',
      },
      {
        id: 3,
        title: 'Шины',
      },
    ];

    const optionsWhoPaysTheRansom = [
      {
        value: '0',
        label: 'За счёт средств клиента',
      },
      {
        value: '1',
        label: 'За счет ТК ЛУЧ',
      },
    ];

    const checkIfArraysAreDifferent = (arr1, arr2) => {
      let areDifferent = false;
      if (arr1.length !== arr2.length) {
        areDifferent = true;
      } else {
        areDifferent = false;
      }

      return areDifferent;
    };

    watch(
      () => dataForm.cargoInformation.typeOfPackaging,
      (newVal, oldVal) => {
        if (checkIfArraysAreDifferent(newVal, oldVal)) {
          useFetchExtraPackaging(true);
        }
      },
      {
        onTrigger(e) {
          // debugger;
        },
      }
    );

    const checkValidityDimension = (value, dimension) => {
      const maxHeight = Math.min(citiesRestrictions.cityFrom?.maxAcceptanceShippingHeight || Infinity, citiesRestrictions.cityTo?.maxAcceptanceShippingHeight || Infinity);
      const maxWeight = Math.min(citiesRestrictions.cityFrom?.maxAcceptanceShippingWeight || Infinity, citiesRestrictions.cityTo?.maxAcceptanceShippingWeight || Infinity);
      const maxSize = Math.min(citiesRestrictions.cityFrom?.maxAcceptanceShippingSize || Infinity, citiesRestrictions.cityTo?.maxAcceptanceShippingSize || Infinity);
      const resetDimensions = () => {
        dataForm.cargoInformation.cargoDimensions.length = '';
        dataForm.cargoInformation.cargoDimensions.width = '';
        dataForm.cargoInformation.cargoDimensions.height = '';
        dataForm.cargoInformation.sizeOfCargoCylinder.height = '';
        dataForm.cargoInformation.sizeOfCargoCylinder.diameter = '';
        dataForm.cargoInformation.cargoWeight = '';
        dataForm.cargoInformation.cargoVolume = '';
      };
      switch (dimension) {
        case 'height':
          if (Number(value) > maxHeight) {
            dialogBadDimensionsInfo.value.open = true;
            dialogBadDimensionsInfo.value.maxHeight = maxHeight;
            dialogBadDimensionsInfo.value.maxWeight = -1;
            dialogBadDimensionsInfo.value.maxSize = -1;
            resetDimensions();
            console.log('Height is too big!');
          }
          break;
        case 'weight':
          if (Number(value) > maxWeight) {
            dialogBadDimensionsInfo.value.open = true;
            dialogBadDimensionsInfo.value.maxWeight = maxWeight;
            dialogBadDimensionsInfo.value.maxHeight = -1;
            dialogBadDimensionsInfo.value.maxSize = -1;
            resetDimensions();
            console.log('Weight is too big!');
          }
          break;
        case 'size':
          if (Number(value) > maxSize) {
            dialogBadDimensionsInfo.value.open = true;
            dialogBadDimensionsInfo.value.maxSize = maxSize;
            dialogBadDimensionsInfo.value.maxHeight = -1;
            dialogBadDimensionsInfo.value.maxWeight = -1;
            resetDimensions();
            console.log('Size is too big!');
          }
          break;
      }
    };

    const calculateVolume = () => {
      if (dataForm.cargoInformation.cargoDimensions.length && dataForm.cargoInformation.cargoDimensions.width && dataForm.cargoInformation.cargoDimensions.height) {
        dataForm.cargoInformation.cargoVolume =
          (dataForm.cargoInformation.cargoDimensions.length * dataForm.cargoInformation.cargoDimensions.width * dataForm.cargoInformation.cargoDimensions.height) / 1000000;
      }
    };

    function checkIntersectionsTypes(types, typeName) {
      return !(dataForm.cargoInformation.typeOfPackaging.filter((type) => types.includes(type)).length === dataForm.cargoInformation.typeOfPackaging.length && checkWarmPlace(typeName));
    }

    function checkWarmPlace(typeName) {
      if (!dataForm.services.warmPlace) {
        return true;
      }
      return typeName === 'Паллетирование' || typeName === 'Поддон' ? false : true;
    }

    const handleChangeCargoParams = (value, type) => {
      if (['height', 'length', 'width', 'diameter'].includes(type)) {
        if (Number(value) < 10) {
          if (dataForm.cargoInformation.typeOfCargo.id === 1) {
            dataForm.cargoInformation.cargoDimensions[type] = 10;
          } else {
            dataForm.cargoInformation.sizeOfCargoCylinder[type] = 10;
          }
        }
        calculateVolume(`cargoDimensions.${type}`);
      }
      if (type === 'width') {
        type = 'size';
      }
      if (type === 'diameter') {
        type = 'size';
      }
      if (type === 'weight') {
        if ([1, 2].includes(dataForm.cargoInformation.typeOfCargo.id)) {
          if (Number(value) < 1) {
            dataForm.cargoInformation.cargoWeight = 1;
          }
        }
      }
      if (type !== 'weight') {
        // checkValidityDimension(value, type);
      }
      handleChangeEventCargoInfo();
    };

    // function handlerWeight() {
    //   if (checkDayToDay(dataForm.applicationCargoPickup.pickupDate) && checkHour() && checkWeight() && checkCity()) {
    //     dataForm.cargoInformation.cargoWeight = 30;
    //   }
    //   dataForm.updateApplicationTimeIsOver();
    // }

    const checkCity = () => dataForm.sender.cityFrom === 'Челябинск' || dataForm.sender.cityFrom === 'Екатеринбург';

    const checkWeight = () => dataForm.cargoInformation.cargoWeight > 30;

    const checkHour = () => new Date().getHours() >= 12;

    const checkingDimensions = (dimensions) => {
      dimensions.sort((a, b) => b - a);
      return dimensions[0] > 100 || dimensions[1] > 70;
    };

    const checkDisabledWarmplace = () => {
      if (
        Number(dataForm.cargoInformation.cargoVolume) > 0.5 ||
        dataForm.cargoInformation.cargoWeight > 30 ||
        checkingDimensions([dataForm.cargoInformation.cargoDimensions.length, dataForm.cargoInformation.cargoDimensions.width, dataForm.cargoInformation.cargoDimensions.height])
      ) {
        dataForm.cargoInformation.warmPlace = false;
        return true;
      }
      return false;
    };

    const checkCargoCost = () => {
      if (dataForm.cargoInformation.cargoCost < 3000) {
        dataForm.cargoInformation.cargoCost = 3000;
      }
      if (dataForm.cargoInformation.cargoCost >= 30000) {
        // dataForm.cargoInformation.additionalPackaging = true
        // if (!dataForm.cargoInformation.typeOfPackaging.includes('Обрешётка')) {
        //   dataForm.cargoInformation.typeOfPackaging.push('Обрешётка')
        // }
      }
    };

    const handleChangeCargoCost = () => {
      checkCargoCost();
      useFetchExtraPackaging();
    };

    onMounted(async () => {
      useFetchExtraPackaging();
    });

    return {
      dataForm,
      handleNatureCargoChange,
      natureOfCargoList,
      checkDisabledWarmplace,
      checkValidityDimension,
      handleChangeCargoParams,
      typeOfCargos,
      handleChangePayer,
      handleChangeTypeOfPayment,
      dialogBadDimensionsInfo,
      checkIntersectionsTypes,
      getArrayOfRules,
      checkDayToDay,
      checkHour,
      optionsWhoPaysTheRansom,
      checkWeight,
      checkCity,
      // handlerWeight,
      cityFromRestrictions,
      cityToRestrictions,

      checkNumberOfIdenticalLoads: function () {
        if (dataForm.cargoInformation.numberOfIdenticalLoads < 1) {
          dataForm.cargoInformation.numberOfIdenticalLoads = 1;
        }
      },
      toggleResetFields(value, propsToReset) {
        propsToReset.forEach((prop) => {
          const [first, second] = prop.split('.');
          dataForm[first][second] = '';
        });
        if (!value) {
          ruleFormRef.value.clearValidate(propsToReset);
        }
      },
      checkRedemption: function () {
        if (dataForm.services.whoPaysTheRansom === '1' && Number(dataForm.services.cargoRedemptionSum) > 6000) {
          dataForm.services.cargoRedemptionSum = 6000;
        }
      },
      handleChangeCargoCost,

      checkPackageType: function () {
        if (dataForm.cargoInformation.cargoCost >= 30000) {
          // if (!dataForm.cargoInformation.typeOfPackaging.includes('Обрешётка')) {
          //   dataForm.cargoInformation.typeOfPackaging.push('Обрешётка')
          // }
          // console.log(dataForm.cargoInformation.typeOfPackaging)
        }
      },

      toggleTypePackaging: function (value) {
        if (!value) {
          ruleFormRef.value.resetFields(['cargoInformation.typeOfPackaging']);
        }
      },
      cargoNatures,
      handleChangeEventCargoInfo,

      handleChangeTypeOfCargo: function () {
        dataForm.cargoInformation.cargoDimensions.length = null;
        dataForm.cargoInformation.cargoDimensions.height = null;
        dataForm.cargoInformation.cargoDimensions.width = null;

        dataForm.cargoInformation.sizeOfCargoCylinder.diameter = null;
        dataForm.cargoInformation.sizeOfCargoCylinder.height = null;

        dataForm.cargoInformation.cargoVolume = null;
        dataForm.cargoInformation.cargoWeight = null;

        useFetchExtraPackaging();

        useFetchSuitableOffices('acceptanceCargo');
        useFetchSuitableOffices('issuanceOfCargo');

        useFetchAvailablePickUpTime();
      },

      calculateVolume,
      citiesRestrictions,

      calculateDimensions: function () {
        const size = Math.round(Math.cbrt(Number(dataForm.cargoInformation.cargoVolume) * 1000000)).toFixed(0);
        dataForm.cargoInformation.cargoDimensions.length = size;
        dataForm.cargoInformation.cargoDimensions.width = size;
        dataForm.cargoInformation.cargoDimensions.height = size;
      },
    };
  },
};
